import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { PopupGreeTick } from '../../../../svgIcons';
import ClassetCalendar from '../../../../../classetComponents/classetCalender';
import { BUTTON_STYLES } from '../constants';

class AdmissionChangeRequestDialog extends Component {
    renderHeader = () => {
        return (
            <div className="mt-2 formHeadingInter">
                <div className="mb-3">
                    <PopupGreeTick />
                </div>
                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Approve Admission Change</p>
            </div>
        );
    };

    renderFooter = () => {
        const { onAccept, onCancel } = this.props;
        
        return (
            <div className="" style={{ display: 'flex' }}>
                <Button
                    style={{
                        ...BUTTON_STYLES.APPROVE,
                        width: '170%',
                        padding: 0,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={onAccept}
                >
                    <p className="text-xl ml-2">Accept</p>
                </Button>
                <Button
                    style={{
                        ...BUTTON_STYLES.REJECT,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={onCancel}
                >
                    <p className="text-xl">Cancel</p>
                </Button>
            </div>
        );
    };

    render() {
        const { 
            visible, 
            onHide, 
            rowData, 
            effectiveDate, 
            onEffectiveDateChange 
        } = this.props;

        return (
            <Dialog
                visible={visible}
                draggable={false}
                closeOnEscape={false}
                className="mr-0"
                style={{ width: 400 }}
                dismissableMask={false}
                closable={false}
                header={this.renderHeader}
                footer={this.renderFooter}
                onHide={onHide}
            >
                <p className="topicName ml-3" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}>
                    <p>Student Name : {rowData?.user_info?.firstName} {rowData?.user_info?.lastName}</p>
                    <p>Branch Name: {rowData?.user_info?.branchName}</p>
                    <p>Phone number : {rowData?.user_info?.parentContactNo}</p>
                    <p>Request Raised by : {rowData?.requestRaisedByName?.slice(3)}</p>
                    <p style={{ color: 'green' }} className="mt-3">
                        {`*Change student Admission Type to ${rowData?.requestedAdmissionName}`}
                    </p>
                </p>
                
                <div className='mt-3'>
                    <ClassetCalendar
                        label={"Effective Date"}
                        className='border-round-md no-border custom-field-focused border-none pl-3 body-medium'
                        calendarMode={'single'}
                        height="48px"
                        width='368px'
                        value={effectiveDate ? new Date(effectiveDate) : null}
                        onChange={onEffectiveDateChange}
                        placeholder="Select Date"
                        disabled={true}
                    />
                </div>
            </Dialog>
        );
    }
}

export default AdmissionChangeRequestDialog;
